export default __webpack_public_path__ + "static/media/Churches.695312f2.jpg";